var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('image',{attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y,"href":_vm.processingItem.asset.preview || _vm.processingItem.preview,"draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }